import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import CombinedShape from "../../../../images/three-dots-vertical.svg";
import CombinedActiveShape from '../../../../images/threeDotsmenu.svg';
import {ReactComponent as Activeswitch} from '../../../../images/activeswitch.svg';
import {ReactComponent as Inactiveswitch} from '../../../../images/inactiveswitch.svg';
import {
  Card,
  Input,
  FormGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

export interface paymentDetailsOption {
  name: String;
  frequence: String;
  format: String;
  isActive: Boolean;
  id: String;
}

export interface PaymentDetailsProps {
  paymentDetails: {
    id: String;
    name: String;
    options: paymentDetailsOption[];
  };
  type: String;
}

const PaymentDetails: React.FC<PaymentDetailsProps> = (
  props: any,
  ref: any
) => {
  const [currentEditableRow, setCurrentEditableRow] = useState<any>({});
  const [menuOpen, setMenuOpen] = useState<any>({});
  const [activeRow, setActiveRow] = useState<any>(null);
  const [isNewRow, setIsNewRow] = useState<Boolean>(false);  
  const [currentDeletableRow, setCurrentDeletableRow] = useState<any>({});

  const onEditCard = (e: any, option: any) => {
    e && e.stopPropagation();
    setCurrentEditableRow(option);   
  }; 
  const onDeleteCard = (e: any, option: any) => {
    e && e.stopPropagation();
    setCurrentDeletableRow(option);
  };

  const toggleMenuOptions = (option: any) => {
    setActiveRow(option.id);
    setMenuOpen({ [option.id]: !menuOpen[option.id] });
  };

  const addRow = () => {
    setIsNewRow(true);

  };

  const cancelRow = () => {  
    setCurrentEditableRow({})
  }
  const cancelNewRow = () => {
    setIsNewRow(false)
  }
   const cancelDeleteRow = () => {
    setCurrentDeletableRow({})
  }
  useEffect(() => {
    setCurrentEditableRow({});
    setIsNewRow(false);
  }, [props.paymentDetails]);

  const renderRow = (option:any)=>{
    if(option?.id === currentEditableRow?.id){
      return  <Row className="addnew-list-row edit-row">
      
          <Col xs="5" className="p-column">
            <Input placeholder="Sample Field Name"></Input>
          </Col>
          <Col xs="2" className="p-column">
          <Input placeholder="Per Item" type='select' name="select">
          <option>Frequency 1</option>    <option>Frequency 2</option>   </Input>
          </Col>
          <Col xs="2" className="p-column">
          <Input placeholder="Per Item" type='select' name="select">
          <option>Format 1</option>    <option>Format 2</option>   </Input>
          </Col>
          <Col xs="3" className="p-column confirm-button"><span className="cancel" onClick = {cancelRow}>Cancel </span><button  className="save">Save</button></Col>
      
  
    </Row>
    }  else if(option?.id === currentDeletableRow?.id){
      return  <Row className="addnew-list-row delete-row">
      
          <Col xs="5" className="p-column">
          <div>Sample Field Name </div>
            {/* <Input placeholder="Sample Field Name"></Input> */}
          </Col>
          <Col xs="2" className="p-column">
          <div>Per Item </div>
          {/* <Input placeholder="Per Item" type='select' name="select">
          <option>Frequency 1</option>    <option>Frequency 2</option>   </Input> */}
          </Col>
          <Col xs="2" className="p-column">
          <div>Frequency</div>
          {/* <Input placeholder="Per Item" type='select' name="select">
          <option>Format 1</option>    <option>Format 2</option>   </Input> */}
          </Col>
          <Col xs="3" className="p-column confirm-deletebutton"><span className="deletecancel" onClick = {cancelDeleteRow}>Cancel </span><button  className="delete">Delete</button></Col>
      
  
    </Row>
    } else {
      return  (
        <Row className={`${activeRow === option.id ? 'chooseRow' : (option.isActive) ? 'addnew-list-row' :'disabled'}`} >
        {props.type === "custom" ? 
            <Col xs="5" className="p-column">
            {option.name}
          </Col>: <Col xs="6" className="p-column">{option.name}</Col>}
          {props.type === "custom" ?
          <Col xs="2" className="p-column">
            {option.frequence}
          </Col>:  <Col xs="3" className="p-column">
            {option.frequence}
          </Col>}
          {props.type === "custom" ?
          <Col xs="2" className="p-column">
            {option.format}
          </Col>:   <Col xs="3" className="p-column">
            {option.format}
          </Col>}
          {props.type === "custom" ?<>
          <Col xs="2" className="p-column In-active ">
            {props.type === "custom" ? (
              <div className="toggle-Inactive">
                <div className={`${option.isActive ?'toggle-active':'toggle-disabled'}`}>
                  {option.isActive ? "Active" : "InActive"}
                </div>
                <div>
                <div  onClick= {() => option.isActive = !option.isActive}>
                  {option.isActive? <Activeswitch className="switch-button"  />:<Inactiveswitch className="switch-button" /> }</div>            
                  {/* <FormGroup switch>
                    <Input
                      type="switch"
                      className="switch-button"
                      checked={option.isActive}
                      onClick={(event:any) => {
                        option.isActive = !option.isActive;
                      }}
                    />
                  </FormGroup> */}
                </div>
              </div>
            ) : (
              <></>
            )}
          </Col>
          <Col xs="1" className="p-column">
            {props.type === "custom" ? (
              <div className="three-dotmenu">
                <Dropdown
                  className="img"
                  toggle={() => toggleMenuOptions(option)}
                  isOpen={menuOpen[option.id]}
                >
                  <DropdownToggle className="three-dots">
                    {activeRow === option.id ?<img
                      src={CombinedActiveShape}                     
                      alt="nothing"
                      className="CombinedShape"
                    />:<img
                    src={CombinedShape}
                    alt="nothing"
                    className="CombinedShape"
                  />}
                  </DropdownToggle>
                  <DropdownMenu
                    container="body"
                    className="three-dots-Options"
                  >
                    <DropdownItem
                      className="edit-item"
                      onClick={(event) => {
                        onEditCard(event, option);                                
                      }}
                    >
                      Edit
                    </DropdownItem>
                    <DropdownItem
                      onClick={(event) => onDeleteCard(event, option)}
                      className="delete-item"
                    >
                      Delete
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
            ) : (
              <></>
            )}
          </Col></>:""}
        </Row>
      )
    }
  
  }

  return (
    <div className="pyment-options">
      {/* <div className="addNewItem">
        <Button onClick={addRow}>Add New Field</Button>
      </div> */}
    
      <Nav tabs>
        <NavItem>
          
          <NavLink  className="active" onClick={function noRefCheck() {}} >
            {props?.paymentDetails?.name}
          </NavLink>    
       
 
        
        </NavItem>
        <NavItem>
          
        {props.type === "custom" ? <NavLink onClick={addRow} className="add-newfield">
            Add New Field
        
          </NavLink>  :<></>  }
       
 
        
        </NavItem>
      </Nav>
      <TabContent activeTab="1" className="addnew-list">
        <TabPane tabId="1">
          {props?.paymentDetails?.options?.map((option: any) => (
              renderRow(option)
          ))}
          {isNewRow ? (
            <Row className="addnew-list-row">
              <Col xs="5" className="p-column">
                <Input placeholder="Sample Field Name"></Input>
              </Col>
              <Col xs="2" className="p-column">
                <Input placeholder="Per Item" type='select' name="select">
                <option>Frequency</option>    <option>Frequency</option>   </Input>
              </Col>
              <Col xs="2" className="p-column">
              <Input placeholder="Per Item" type='select' name="select">
                <option>Format </option>    <option> Format</option>   </Input>
              </Col>
           
              <Col xs="3" className="p-column confirm-button"><span className="cancel" onClick = {cancelNewRow}>Cancel </span><button className="save">Save</button></Col>
           
            
            </Row>
          ) : (
            <>{props.type === "custom" ?<Row className="addnew-row" onClick={addRow}>Add New Field</Row>:<></>}</>
          )}
        </TabPane>
      </TabContent>
    </div>
  );
};

export default PaymentDetails;
